import React, { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { injectModels } from "../../redux/injectModels";

const CreateSession = (props) => {
  const buttonRef = useRef(null);
  const [error, setError] = useState("");
  const [model, setModel] = useState(false);
  const navigate = useNavigate();
  const [sessionName, setSessionName] = useState("");
  const [jobProfile, setJobProfile] = useState("");
  const [company, setCompany] = useState("");
  const [interviewer, setInterviewer] = useState("");
  const [interviewee, setInterviewee] = useState("");
  const [topic, setTopic] = useState("");

  const [sessionNameError, setSessionNameError] = useState("");
  const [jobProfileError, setJobProfileError] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [interviewerError, setInterviewerError] = useState("");
  const [intervieweeError, setIntervieweeError] = useState("");
  const [topicError, setTopicError] = useState("");

  const handleSessionName = (e) => {
    const val = e.target.value;
    if (val === "") {
      setSessionNameError("Session Name is required!");
    } else {
      setSessionNameError("");
    }
    setSessionName(val);
  };

  const handleJobProfile = (e) => {
    const val = e.target.value;
    if (val === "") {
      setJobProfileError("Job Profile is required!");
    } else {
      setJobProfileError("");
    }
    setJobProfile(val);
  };
  const handleCompany = (e) => {
    const val = e.target.value;
    if (val === "") {
      setCompanyError("Company name is required!");
    } else {
      setCompanyError("");
    }
    setCompany(val);
  };

  const handleInterviewer = (e) => {
    const val = e.target.value;
    if (val === "") {
      setInterviewerError("Interviewer Name is required!");
    } else {
      setInterviewerError("");
    }
    setInterviewer(val);
  };

  const handleInterviewee = (e) => {
    const val = e.target.value;
    if (val === "") {
      setIntervieweeError("Interviewee Name is required!");
    } else {
      setIntervieweeError("");
    }
    setInterviewee(val);
  };

  const handleTopic = (e) => {
    const val = e.target.value;
    if (val === "") {
      setTopicError("Topic Name is required!");
    } else {
      setTopicError("");
    }
    setTopic(val);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let error = true;

    if (sessionName.trim() === "") {
      error = false;
      setSessionNameError("Session Name is required!");
    } else {
      setSessionNameError("");
    }

    if (jobProfile.trim() === "") {
      error = false;
      setJobProfileError("Job Profile Name is required!");
    } else {
      setJobProfileError("");
    }
    if (company.trim() === "") {
      error = false;
      setCompanyError("Company name is required!");
    } else {
      setCompanyError("");
    }
    if (interviewer.trim() === "") {
      error = false;
      setInterviewerError("Interviewer Name is required!");
    } else {
      setInterviewerError("");
    }
    if (interviewee.trim() === "") {
      error = false;
      setIntervieweeError("Interviewee Name is required!");
    } else {
      setIntervieweeError("");
    }
    if (topic.trim() === "") {
      error = false;
      setTopicError("Topic Name is required!");
    } else {
      setTopicError("");
    }

    if (!error) {
      setError("Please fill all fields!");
      return;
    } else {
      setError("");

      try {
        let data = {
          title: sessionName,
          job_profile: jobProfile,
          company_name: company,
          user: interviewee,
          client: interviewer,
          topic: topic,
        };
        props.application.setLoading(true);
        const res = await props.admin.createSession(data);
        if (res.success === true) {
          props.application.setLoading(false);
          toast.dismiss();
          toast.success(res.message, {
            position: toast.POSITION.TOP_CENTER,
          });

          handleReset();
          navigate("/session");

          const button = buttonRef.current;
          if (button) {
            button.click();
          }
        } else {
          toast.dismiss();
          toast.error(res.message, {
            position: toast.POSITION.TOP_CENTER,
          });
          props.application.setLoading(false);
        }
      } catch (error) {
        console.log(error);
        props.application.setLoading(false);
        toast.dismiss();
        toast.error("Something went wrong!", {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    }
  };

  const handleReset = () => {
    setSessionName("");
    setJobProfile("");
    setInterviewee("");
    setInterviewer("");
    setTopic("");
    setCompany("");

    setSessionNameError("");
    setJobProfileError("");
    setIntervieweeError("");
    setInterviewerError("");
    setTopicError("");
    setCompanyError("");
    setError("");
  };

  return (
    <>
      <div className="modal fade" id="largeModal" tabIndex="-1">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Create Session</h5>
              <button
                ref={buttonRef}
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                onClick={handleReset}
              ></button>
            </div>
            <div className="modal-body">
              <form className="row g-3 p-2" onSubmit={handleSubmit}>
                <div className="col-md-12 mt-1"></div>

                <div className="col-md-6">
                  <label htmlFor="" className="form-label">
                    Title
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={sessionName}
                    onChange={handleSessionName}
                  />
                  {sessionNameError && (
                    <div className="text-danger">{sessionNameError}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label htmlFor="" className="form-label">
                    Job Profile
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={jobProfile}
                    onChange={handleJobProfile}
                    maxLength={250}
                  />
                  {jobProfileError && (
                    <div className="text-danger">{jobProfileError}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label htmlFor="" className="form-label">
                    Company Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={company}
                    onChange={handleCompany}
                    maxLength={250}
                  />
                  {companyError && (
                    <div className="text-danger">{companyError}</div>
                  )}
                </div>

                <div className="col-md-6">
                  <label htmlFor="" className="form-label">
                    Interviewer (client)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={interviewer}
                    onChange={handleInterviewer}
                    maxLength={240}
                  />
                  {interviewerError && (
                    <div className="text-danger">{interviewerError}</div>
                  )}
                </div>
                <div className="col-md-6">
                  <label htmlFor="" className="form-label">
                    Interviewee (user)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id=""
                    value={interviewee}
                    onChange={handleInterviewee}
                    maxLength={240}
                  />
                  {intervieweeError && (
                    <div className="text-danger">{intervieweeError}</div>
                  )}
                </div>
                <div className="col-md-6">
                  <label htmlFor="" className="form-label admore">
                    Topic
                  </label>
                  <select
                    className="form-select"
                    value={topic}
                    onChange={handleTopic}
                  >
                    <option value="">Select Topic</option>
                    <option value="Insurance">Insurance</option>
                    <option value="Purchase Coordinator">
                      Purchase Coordinator
                    </option>
                    <option value="Secondary Sales Coordinator">
                      Secondary Sales Coordinator
                    </option>
                    <option value="Vendor cost subsheet">
                      Vendor cost subsheet
                    </option>
                    <option value="Services FMS Sheet">
                      Services FMS Sheet
                    </option>
                  </select>
                  {topicError && (
                    <div className="text-danger">{topicError}</div>
                  )}
                </div>
                {error && (
                  <div className="col-xs-12 col-md-12 col-lg-12">
                    <div className="alert alert-danger">{error}</div>
                  </div>
                )}

                <div className="mbtn-row">
                  <button
                    type="button"
                    className="btn btn-secondary m-0"
                    onClick={handleReset}
                  >
                    Reset
                  </button>
                  <button type="submit" className="btn btn-primary m-0">
                    Create
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default injectModels(["admin", "application"])(CreateSession);
